var map = {
	"./about-us.svg": 753,
	"./betting-icon.svg": 754,
	"./bonus.svg": 755,
	"./coin.svg": 756,
	"./contact-us.svg": 757,
	"./download-app.svg": 758,
	"./edit-btn.svg": 759,
	"./feedback.svg": 760,
	"./global.svg": 761,
	"./info-centre.svg": 762,
	"./info-centre.webp": 1635,
	"./instant-rebate.svg": 763,
	"./mall-icon.svg": 764,
	"./message.svg": 765,
	"./personal-info-edit.svg": 766,
	"./r77-coin.svg": 767,
	"./r77-rewards.svg": 768,
	"./redemption-icon.svg": 769,
	"./referral.svg": 770,
	"./resp-gaming.svg": 771,
	"./security.svg": 772,
	"./transaction-icon.svg": 773,
	"./vip-icon.svg": 774,
	"./wallet-icon.svg": 775
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 752;